import { mapCollection } from '../../utils/collection.utils';
import { SchedulerTaskWithModelTimeLineSimple } from '../scheduler-task-with-model-timeline-simple';
import { SchedulerTaskSubTaskSimpleBuilder } from './scheduler-task-subtask-simple.builder';

export class SchedulerTaskWithModelTimeLineSimpleBuilder {
  static fromJson(json) {
    return (json)
      ? new SchedulerTaskWithModelTimeLineSimple(
        json.hash,
        json.schedulerTaskVersionHash,
        json.modelHash,
        json.startDate,
        json.endDate,
        json.status,
        json.deviation,
        json.current,
        json.finished,
        json.started,
        json.isPendingProgramDefinition,
        json.putAdditionalTimes,
        json.removeAdditionalTimes,
        json.programDefinition,
        json.manufacturingOrderCode,
        json.manufacturingOrderHash,
        json.manufacturingOrderIsClaimed,
        json.operationCode,
        json.hasMaterialReady,
        json.hasMaterialInStock,
        json.mpReady,
        SchedulerTaskSubTaskSimpleBuilder.fromList(json.subTasks)
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(SchedulerTaskWithModelTimeLineSimpleBuilder.fromJson, list);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/scheduler-task-with-model-timeline-simple.builder.ts